import { LayoutAdminCafe } from "../../../layout/layout_cafe";
import TableUser from "./components/tableUser";

export function UserManagementCafe() {
  return (
    <>
      <LayoutAdminCafe>
        <TableUser/>
      </LayoutAdminCafe>
    </>
  );
}